export enum SubSourceType {
    Whatsapp = 'Whatsapp',
    Phone = 'Teléfono',
    Web = 'Web'
}
